import { render, staticRenderFns } from "./AddCost.vue?vue&type=template&id=b8a0fff4&"
import script from "./AddCost.vue?vue&type=script&lang=js&"
export * from "./AddCost.vue?vue&type=script&lang=js&"
import style0 from "./AddCost.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports